module.exports = __webpack_public_path__ + "img/司机1.394472dc.png";